import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navigation = [{
  label: 'Expertise',
  target: 'expertise'
}, {
  label: 'Approach',
  target: 'approach'
}, {
  label: 'Results',
  target: 'testimonials'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (target: string) => {
    document.getElementById(target)?.scrollIntoView({
      behavior: shouldReduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
    setIsMenuOpen(false);
  };
  return <header className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color,box-shadow] duration-200 ease-out ${isScrolled ? 'border-white/10 bg-[#0A1628]/95 shadow-[0_12px_40px_rgba(2,8,23,0.22)] backdrop-blur-xl' : 'border-transparent bg-transparent'}`} data-id="element-2" data-mp="2wkuoczihrt8x">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8" data-id="element-3" data-mp="2hodekcpyamoh">
        <button type="button" onClick={() => scrollTo('hero')} className="whitespace-nowrap font-serif text-xl font-semibold text-white transition-colors duration-150 ease-out hover:text-[#E5C76B] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] focus-visible:ring-offset-4 focus-visible:ring-offset-[#0A1628]" data-id="element-4" data-mp="3fbvo3prfrstj">
          Dr. Ali Mazloum
        </button>

        <nav aria-label="Primary navigation" className="hidden items-center gap-8 md:flex" data-id="element-5" data-mp="1x7oe7v86qru">
          {navigation.map(item => <button key={item.target} type="button" onClick={() => scrollTo(item.target)} className="whitespace-nowrap text-sm font-medium text-white/75 transition-colors duration-150 ease-out hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]" data-id="element-6" data-mp="3t90nx80k3vgc">
              {item.label}
            </button>)}
          <button type="button" onClick={() => scrollTo('booking')} className="whitespace-nowrap bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#0A1628] transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#E5C76B] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-4 focus-visible:ring-offset-[#0A1628]" data-id="element-7" data-mp="18n3e4ldj92id">
            Book meeting
          </button>
        </nav>

        <button type="button" aria-expanded={isMenuOpen} aria-controls="mobile-navigation" aria-label={isMenuOpen ? 'Close navigation' : 'Open navigation'} onClick={() => setIsMenuOpen(open => !open)} className="p-2 text-white transition-colors duration-150 ease-out hover:text-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] md:hidden" data-id="element-8" data-mp="2y1rokh2kcadr">
          {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-9" data-mp="rcg9wxo0ss6i" /> : <MenuIcon className="h-6 w-6" data-id="element-10" data-mp="1555ucxnwhp1i" />}
        </button>
      </div>

      <AnimatePresence data-id="element-11" data-mp="153bcjs7xed1n">
        {isMenuOpen && <motion.nav id="mobile-navigation" aria-label="Mobile navigation" initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={shouldReduceMotion ? undefined : {
        opacity: 0,
        y: -8
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/10 bg-[#0A1628] px-5 pb-6 pt-3 md:hidden" data-id="element-12" data-mp="106umgsh61olx">
            <div className="mx-auto flex max-w-7xl flex-col" data-id="element-13" data-mp="22yxc5bugv6l1">
              {navigation.map(item => <button key={item.target} type="button" onClick={() => scrollTo(item.target)} className="border-b border-white/10 py-4 text-left text-base font-medium text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-14" data-mp="27x8mrosl5l4b">
                  {item.label}
                </button>)}
              <button type="button" onClick={() => scrollTo('booking')} className="mt-5 bg-[#D4AF37] px-6 py-3.5 font-semibold text-[#0A1628] transition-colors duration-150 ease-out hover:bg-[#E5C76B]" data-id="element-15" data-mp="1p6qvzprbczll">
                Book meeting
              </button>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}